import React from 'react';
import Search from './components';

export default function Login() {
	return <Search />;
}
